import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
// THIS BREAKS THE AUTH. The redirect URL is derived at button click time from
// window.location.origin — this page only reads the session_id fragment.
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    // Strip fragment so the token isn't visible / reprocessed on back-nav.
    window.history.replaceState(null, "", window.location.pathname + window.location.search);

    if (!sessionId) {
      toast.error("Missing session ID from Google");
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        localStorage.setItem("riddhi_token", data.token);
        await refresh();
        toast.success(`Welcome ${data.user?.name?.split(" ")[0] || ""}`.trim());
        navigate("/", { replace: true });
      } catch (e) {
        toast.error(formatApiError(e.response?.data?.detail) || "Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-[80vh] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="inline-block h-10 w-10 border-2 border-stone-300 border-t-[#D4AF37] rounded-full animate-spin" />
        <div className="mt-6 text-sm tracking-overline uppercase text-stone-500">Signing you in</div>
      </div>
    </div>
  );
}
